<div class="row">
  <div class="col-xs-12">
    <section class="scyr-login">
      <h1>Bienvenido a la Oficina Virtual de {{pie}}</h1>
      <alertbox
        [messageBox]="messageCabecera"
        [typeException]="typeException"
        [messageComplet]="messageComplet"
      >
      </alertbox>
      <span class="border-pattern"></span>
      <div class="scyr-login-box">
        <div class="scyr-login-box-resp">
          <span class="border-pattern"></span>
          <div class="scyr-login-box-resp__text">
            <h2>Acceda a su cuenta</h2>
            <form
              class=""
              id="form"
              method="get"
              action=""
            >
              <fieldset>
                <legend class="sr-only">Formulario acceso</legend>
                <div class="input-form input-select">
                  <label
                    for="poblacion"
                    class="slct"
                  >Población</label>
                  <div class="select">
                    <select
                      name="provincia"
                      (change)="CambioPoblacion()"
                      [(ngModel)]="poblacion"
                      required
                    >
                      <option
                        value="-1"
                        disabled
                        selected
                      >Seleccione una población</option>
                      <option
                        *ngFor="let explotacion of explotaciones; let i = index"
                        value={{i}}
                      >
                        {{explotacion.Descripcion}}</option>
                    </select>
                  </div>
                  <span
                    *ngIf="poblacionInputError == true"
                    class="error"
                  >Introduzca una población</span>
                </div>

                <sacyr-input
                  [setType]="'text'"
                  [setName]="'usuario'"
                  [setLabel]="'Usuario'"
                  [setValue]="usuario"
                  [setRequired]="true"
                  (outValue)="usuario = $event"
                ></sacyr-input>

                <sacyr-input
                  [setType]="'password'"
                  [setName]="'password'"
                  [setLabel]="'Contraseña'"
                  [setValue]="password"
                  [setRequired]="true"
                  (outValue)="password = $event"
                ></sacyr-input>

                <div class="input-form input-button">
                  <button
                    [disabled]="connectionError === true"
                    type="submit"
                    class="btn-default"
                    (click)="login($event)"
                    value=""
                  >Acceder</button>
                </div>
                <a
                  *ngIf="connectionError === false"
                  [routerLink]="['/public/resetPassword']"
                  class="login-olvido"
                >¿Ha olvidado su contraseña?</a>
              </fieldset>
            </form>
          </div>
        </div>
        <div class="scyr-login-box-resp">
          <span class="border-pattern"></span>
          <div class="scyr-login-box-resp__text">
            <h2>¿Aún no tiene usuario?</h2>
            <img
              src="assets/images/icons/icono-login.svg"
              alt=""
            >
            <p>Regístrese ahora para disfrutar de todas las ventajas de la oficina online</p>
            <ul class="login-list">
              <li>Sin horarios</li>
              <li>Sin esperas telefónicas</li>
              <li>Cuándo y dónde quiera</li>
            </ul>
            <a
              *ngIf="!connectionError"
              [routerLink]="['/public/register']"
              class="nav-link"
              href="#"
              class="btn-default registro"
            >Regístrese</a>
            <a
              *ngIf="!connectionError && isEmmasa"
              class="nav-link"
              href="https://www2.caixabank.es/apl/pagos/index_es.html?CODCPR=90INI001"
              class="btn-default btn-secondary registro"
            >Pago Online</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
